export default __webpack_public_path__ + "static/media/cleaning7.f311e945.jpg";